import { cn } from "@aichat/ui/lib/utils";

function GrowShrinkLoader(props: { isThemeSleek?: boolean }) {
  const delays = ["0s", "0.3s", "0.6s", "0.9s"];
  return (
    <div className="flex gap-1.5">
      {delays.map((delay, index) => (
        <Circle key={index} delay={delay} isThemeSleek={props.isThemeSleek} />
      ))}
    </div>
  );
}

function Circle({
  delay,
  isThemeSleek,
}: {
  delay: string;
  isThemeSleek?: boolean;
}) {
  return (
    <div
      className={cn(
        "w-[4px] h-[4px] bg-neutral-300 rounded-full animate-grow-shrink",
        isThemeSleek ? "bg-neutral-400" : "",
      )}
      style={{ animationDelay: delay }}
    />
  );
}

export default GrowShrinkLoader;
